import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { ReactComponent as TwIcon } from "../../assets/icons/tw-icon.svg";
import { ReactComponent as InstaIcon } from "../../assets/icons/insta-icon.svg";
import { ReactComponent as MedIcon } from "../../assets/icons/med-icon.svg";
import { ReactComponent as DiscordIcon } from "../../assets/icons/discord-icon.svg";
import { ReactComponent as InIcon } from "../../assets/icons/ln-icon-gray.svg";

const socialsData = [
  {
    Icon: TwIcon,
    path: "http://twitter.com/MetaTorOfficial",
    key: "tw",
    alt: "twitter social icon",
  },
  {
    Icon: InIcon,
    path: "https://www.linkedin.com/company/metator-official/",
    key: "In",
    alt: "linkedin social icon",
  },
  {
    Icon: InstaIcon,
    path: "https://instagram.com/metatorofficial",
    key: "insta",
    alt: "instagram social icon",
  },
  {
    Icon: MedIcon,
    path: "/",
    key: "med",
    alt: "medium social icon",
  },
  {
    Icon: DiscordIcon,
    path: "/",
    key: "dis",
    alt: "discord social icon",
  },
];

function SocialLinks({ className = "", ...rest }) {
  return (
    <ul className={clsx("flex items-center", className)} {...rest}>
      {socialsData.map(({ key, path, Icon }) => (
        <li key={key} className="mr-4 last:m-0">
          <a href={path} target="_blank" rel="noreferrer">
            <Icon
              width={20}
              className="svg-fill--primary hover:scale-150 transition-all duration-300"
            />
          </a>
        </li>
      ))}
    </ul>
  );
}

export default SocialLinks;

SocialLinks.propTypes = {
  className: PropTypes.string,
};
